import { jsxs as r, jsx as o } from "react/jsx-runtime";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import h from "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import b from "@material-ui/core/ListItemIcon";
import k from "@material-ui/core/ListItemText";
import C from "@material-ui/core/Menu";
import x from "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
import { useState as v } from "react";
const Jt = ({ title: a, options: m = [], className: d, value: c = {}, onChange: p }) => {
  const [e, n] = v(), s = (t) => {
    n(t.currentTarget);
  }, l = () => {
    n(void 0);
  }, u = (t) => (i) => {
    t.disabled || (typeof p == "function" && p(t), typeof t.onClick == "function" && t.onClick(i), l());
  }, f = m.find((t) => t.value === c) ?? {};
  return /* @__PURE__ */ r("div", { "data-testid": "menu-container", className: d ?? "", children: [
    /* @__PURE__ */ r(h, { "data-testid": "menu-button", onClick: s, variant: "outlined", fullWidth: !0, children: [
      a,
      " ",
      f.label ?? ""
    ] }),
    /* @__PURE__ */ o(
      C,
      {
        "data-testid": "menu-options",
        anchorEl: e,
        keepMounted: !0,
        open: !!e,
        onClose: l,
        children: m.map((t, i) => /* @__PURE__ */ r(
          x,
          {
            "data-testid": "menu-item",
            onClick: u(t),
            disabled: t.disabled,
            children: [
              t.icon ? /* @__PURE__ */ o(b, { children: t.icon }) : null,
              /* @__PURE__ */ o(k, { primary: t.label })
            ]
          },
          `${t.label}-${i}`
        ))
      }
    )
  ] });
};
export {
  Jt as default
};
//# sourceMappingURL=Menu.js.map
